import { useTranslation } from 'react-i18next';
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import './Error.scss';

export interface Props {
    rtl: boolean;
}

function TrackOrderError({ rtl }: Props) {
    const { t } = useTranslation();
    const dir = rtl ? 'right': 'left';

    const win: any = window;

    const handleGoBackHome = () => {
        window.location = win['home_page_url'];
    }

    const handleGoBackAccountInfo = () => {
        window.location = win['track_order_page_url'];
    }

    return (
        <div className="container">
            <div className="row">
                <div className={`col-sm-12 trackorder-error-container fontFamily-${dir}`}>
                    <Typography className={`trackorder-error-text error-${dir}`} rtl={rtl}>
                        {t('Trackorder_Error')}
                    </Typography>
                    <Typography className={`trackorder-error-supportText error-${dir}`} rtl={rtl}>
                        {t('Tryagain_with_tracknumber')}
                    </Typography>
                    <div className={`goback-buttons-group-${dir} `}>
                        <IconButton className='trackorder-goback-btn' rtl={rtl} onClick={handleGoBackAccountInfo}>{t('Try_again')}</IconButton>
                    </div>
                        <IconButton primary={false} className='goback-HomePage' rtl={rtl} onClick={handleGoBackHome}>{t('GoBack_Homepage')}</IconButton>
                </div>
            </div>
        </div>
    )
}

export default TrackOrderError
